// extracted by mini-css-extract-plugin
export default {"inStock":"stocklabel_inStock__YB1Bv","outOfStock":"stocklabel_outOfStock__l0cAs","lowOnStock":"stocklabel_lowOnStock__p0C8P"};